import React, { Component, Fragment } from "react";
import {
  Modal,
  Icon,
  Button,
  Input,
  Dropdown,
  List,
  Segment,
  Accordion,
  Form,
  Label,
  Message
} from "semantic-ui-react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withApollo } from "@apollo/react-hoc";

import { userFetchData } from "../../store/actions/UserActions";
import gql from "graphql-tag";

class UserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      accordionOpen: 1,
      successMessage: true,
      edit: "",
      oldPassword: "",
      newPassword: "",
      repeatPassword: "",
      name: props.user.name,
      email: props.user.email,
      organization: props.user.organization,
      link_web: props.user.link_web,
      error: { hidden: true, header: "Errore", content: "error" },
      userVariable: [
        { key: "name", translate: "TBL_NAME" },
        { key: "email", translate: "TBL_EMAIL" },
        { key: "organization", translate: "TBL_ORG" },
        { key: "link_web", translate: "TBL_LWEB" }
      ]
    };
  }

  // Handle trigger edit
  handleEdit(type, e) {
    if (type && this.state.edit === "") {
      this.setState({ edit: type, [type]: this.props.user[type] });
    } else {
      this.setState({ edit: "" });
    }
  }

  // Handle all input change
  handleInput(type, e) {
    this.setState({ [type]: e.target.value });
  }

  // Handle open/close modal
  openCloseModal() {
    if (this.state.modalOpen) {
      this.setState({
        modalOpen: !this.state.modalOpen,
        accordionOpen: 1,
        edit: "",
        oldPassword: "",
        newPassword: "",
        repeatPassword: "",
        successMessage: true,
        error: { hidden: true, header: "Errore", content: "test" }
      });
    } else {
      this.setState({ modalOpen: !this.state.modalOpen });
    }
  }

  // Update the user normal data
  updateUser(data, e) {
    const mutation = gql`
      mutation updateUser {
        update_simcaa_t_users(where: {id: {_eq: ${
          this.props.user.id
        }}}, _set: {${[data]}: "${this.state[data]}"}) {
          affected_rows
        }
      }
    `;
    this.props.client
      .mutate({ mutation })
      .then(data => {
        this.props.updateUserInfo(false, false, this.props.user.user);
        this.handleEdit(data);
      })
      .catch(error => console.log(error));
  }

  // Change password
  updatePassword() {
    let localError = Object.assign({}, this.state.error);

    if (this.state.newPassword !== "" && this.state.repeatPassword !== "") {
      if (this.state.newPassword === this.state.repeatPassword) {
        let myHeadersToken = new Headers();
        myHeadersToken.append("Content-Type", "application/json");

        const username = JSON.stringify({ username: this.props.user.user });

        let requestOptionsToken = {
          method: "POST",
          headers: myHeadersToken,
          body: username,
          redirect: "follow"
        };

        // Get new secret token
        fetch(window.env.GenerateSecretToken, requestOptionsToken)
          .then(response => response.json())
          .then(result => {
            if (result.secret_token) {
              let myHeadersPassword = new Headers();
              myHeadersPassword.append("Content-Type", "application/json");

              const body = JSON.stringify({
                secret_token: result.secret_token,
                password: this.state.newPassword
              });

              let requestOptions = {
                method: "POST",
                headers: myHeadersPassword,
                body,
                redirect: "follow"
              };

              // Change password
              fetch(window.env.UpdatePassword, requestOptions)
                .then(response => response.text())
                .then(result => {
                  if (result === "OK") {
                    localError.hidden = true;
                    this.setState({
                      error: localError,
                      successMessage: !this.state.successMessage
                    });
                  } else {
                    // PASSWORD ERROR
                    localError.content = this.props.t("PWD_APIERROR");
                    localError.hidden = false;
                    this.setState({ error: localError, successMessage: true });
                  }
                })
                .catch(error => console.log("error", error));
            } else {
              // ERROR in secret token
              localError.content = result.error || "Error";
              localError.hidden = false;
              this.setState({ error: localError, successMessage: true });
            }
          })
          .catch(error => console.log("error", error));
      } else {
        // ERROR in data
        localError.content = this.props.t("PWD_MISMATCH");
        localError.hidden = false;
        this.setState({ error: localError, successMessage: true });
      }
    } else {
      // ERROR in data
      localError.content = this.props.t("PWD_FILLFORM");
      localError.hidden = false;
      this.setState({ error: localError, successMessage: true });
    }
  }

  // MAIN RENDER
  render() {
    const { t } = this.props;

    let labelPassword;
    if (this.state.newPassword !== "" || this.state.repeatPassword !== "") {
      if (this.state.newPassword === this.state.repeatPassword) {
        labelPassword = (
          <Label color="green" pointing="left">
            Le password inserite coincidono!
          </Label>
        );
      } else {
        labelPassword = (
          <Label color="red" pointing="left">
            Le password inserite non coincidono!
          </Label>
        );
      }
    }

    return (
      <Modal
        closeOnDimmerClick={false}
        trigger={
          <Dropdown.Item onClick={this.openCloseModal.bind(this)}>
            {t("HOME_NAVBAR_USER_PROFILE")}
          </Dropdown.Item>
        }
        open={this.state.modalOpen}
      >
        <Modal.Header>Profilo di {this.props.user.name}</Modal.Header>
        <Modal.Content>
          <Segment textAlign="center" basic>
            <Icon name="user" size="massive" style={{ textAlign: "center" }} />
          </Segment>
          <List divided relaxed>
            <List.Item header={t("TBL_USR")} content={this.props.user.user} />
            {this.state.userVariable.map((item, index) => {
              return (
                <List.Item key={index}>
                  <List.Header>{t(item.translate)}</List.Header>
                  <List.Content>
                    {this.state.edit === item.key ? (
                      <Fragment>
                        <Input
                          value={this.state[item.key]}
                          onChange={this.handleInput.bind(this, item.key)}
                        />
                        <div style={{ paddingLeft: "10px", display: "inline" }}>
                          <Icon
                            name="check"
                            color="green"
                            circular
                            inverted
                            onClick={this.updateUser.bind(this, item.key)}
                            className="icon-pointer"
                          />
                          <Icon
                            name="cancel"
                            color="red"
                            circular
                            inverted
                            onClick={this.handleEdit.bind(this, item.key)}
                            className="icon-pointer"
                          />
                        </div>
                      </Fragment>
                    ) : (
                      <div style={{ display: "inline" }}>
                        {this.props.user[item.key]}
                        <Icon
                          name="edit"
                          size="large"
                          style={{ paddingLeft: "10px" }}
                          className="icon-pointer"
                          onClick={this.handleEdit.bind(this, item.key)}
                          disabled={this.state.edit !== "" ? true : false}
                        />
                      </div>
                    )}
                  </List.Content>
                </List.Item>
              );
            })}
            <List.Item
              header={t("TBL_GROUP")}
              content={this.props.user.role.role_desc}
            />
          </List>
          <Accordion styled style={{ width: "100%" }}>
            <Accordion.Title
              active={this.state.accordionOpen === 0}
              index={0}
              onClick={() =>
                this.setState({ accordionOpen: 1 - this.state.accordionOpen })
              }
            >
              <Icon name="dropdown" />
              {t("MAIN_PROFILE_PWDCHANGE")}
            </Accordion.Title>
            <Accordion.Content active={this.state.accordionOpen === 0}>
              <Form>
                <Form.Field width={16}>
                  <label>{t("MAIN_PROFILE_PWDOLD")}</label>
                  <input
                    placeholder={t("MAIN_PROFILE_PWDOLD")}
                    value={this.state.oldPassword}
                    onChange={this.handleInput.bind(this, "oldPassword")}
                    type="password"
                    style={{ width: "50%" }}
                  />
                  {(this.state.newPassword !== "" ||
                    this.state.repeatPassword !== "") &&
                  this.state.oldPassword === "" ? (
                    <Label color="red" pointing="left">
                      Devi inserire anche la tua vecchia password!
                    </Label>
                  ) : null}
                </Form.Field>
                <Form.Field width={16}>
                  <label>{t("MAIN_PROFILE_PWDNEW")}</label>
                  <input
                    placeholder={t("MAIN_PROFILE_PWDNEW")}
                    value={this.state.newPassword}
                    onChange={this.handleInput.bind(this, "newPassword")}
                    type="password"
                    style={{ width: "50%" }}
                  />
                  {labelPassword}
                </Form.Field>
                <Form.Field width={16}>
                  <label>{t("MAIN_PROFILE_PWDREPEAT")}</label>
                  <input
                    placeholder={t("MAIN_PROFILE_PWDREPEAT")}
                    value={this.state.repeatPassword}
                    onChange={this.handleInput.bind(this, "repeatPassword")}
                    type="password"
                    style={{ width: "50%" }}
                  />
                  {labelPassword}
                </Form.Field>
                <Button positive onClick={this.updatePassword.bind(this)}>
                  {t("MAIN_PROFILE_PWDUPDATE")}
                </Button>
              </Form>
              <Message
                hidden={this.state.error.hidden}
                negative
                icon="exclamation circle"
                header={this.state.error.header}
                content={this.state.error.content}
              />
              <Message
                hidden={this.state.successMessage}
                positive
                icon="check"
                header={"Successo!!!"}
                content={"password cambiata correttamente"}
              />
            </Accordion.Content>
          </Accordion>
        </Modal.Content>
        <Modal.Actions>
          <Button negative onClick={this.openCloseModal.bind(this)}>
            {t("HEAD_BTN_CLOSE")}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateUserInfo: (noInit, isLogin, username) =>
      dispatch(userFetchData(noInit, isLogin, username))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withApollo(translate("translations")(UserProfile)));



// WEBPACK FOOTER //
// ./src/containers/homepage/UserProfile.js